<template>
  <div class="sureInformation">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.sureInformation.nextPage') }}>{{
              $t('setAccount.distribution.confirmledgerInformation')
            }}
          </div>
        </template>
        <div class="collapse-content">
          <el-steps :active="2" align-center>
            <el-step
              :title="$t('setAccount.distribution.essentialInformation')"
              icon="el-icon-success"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.distributionLegalEntity')"
              icon="el-icon-time"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.confirmledgerInformation')"
              icon="el-icon-place"
            ></el-step>
          </el-steps>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.accountList.primaryLedger') }}
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            :auto-resize="true"
            show-overflow
            ref="mainTypeTable"
            class="vxe-table-element"
            :data="SetInformation"
            :columns="mainTypeDataColumn"
          ></vxe-grid>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.viewAccount.corporateInformation') }}
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            :auto-resize="true"
            show-overflow
            ref="InformationTable"
            class="vxe-table-element"
            :data="Distribution"
            :columns="InformationDataColumn"
          ></vxe-grid>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  // import API from '@/api/systemManage/accountManage';
  export default {
    name: 'sureInformation',
    components: {},
    computed: {},
    props: ['SetInformation', 'Distribution'],
    data() {
      return {
        activeNames: ['1', '2', '3'],
        validRules: {
          ledgerCode: [
            {
              required: true,
              message: this.$t('setAccount.accountList.ledgerCode'),
            },
          ],
          ledgerName: [
            {
              required: true,
              message: this.$t('setAccount.sureInformation.writeledgerName'),
            },
          ],
          accountChartCode: [
            {
              required: true,
              message: this.$t('setAccount.sureInformation.accountChartCode'),
            },
          ],
          accountCalendarCode: [
            {
              required: true,
              message: this.$t('setAccount.sureInformation.accountCalendarCode'),
            },
          ],
          currencyCode: [
            {
              required: true,
              message: this.$t('setAccount.sureInformation.currencyCode'),
            },
          ],
        },
        // mainTypeData: [], //主要分类账信息
        // InformationData:[],//法人信息
        mainTypeDataColumn: [
          { type: 'seq', title: this.$t('setAccount.sureInformation.index'), width: 80 },
          { field: 'ledgerCode', title: this.$t('setAccount.accountList.ledgerCode') },
          { field: 'ledgerName', title: this.$t('setAccount.setInformation.ledgerName') },
          {
            field: 'accountChartCode',
            title: this.$t('setAccount.setInformation.accountChartCode'),
          },
          {
            field: 'accountCalendarCode',
            title: this.$t('setAccount.viewAccount.accountCalendarCode'),
          },
          { field: 'currencyCode', title: this.$t('setAccount.accountList.currencyName') },
        ],
        InformationDataColumn: [
          { type: 'seq', title: this.$t('setAccount.sureInformation.index'), width: 80 },
          { field: 'legalEntityName', title: this.$t('setAccount.accountList.legalEntityName') },
          { field: 'legalEntityCode', title: this.$t('setAccount.viewAccount.legalEntityCode') },
          {
            field: 'legalEntityRegionCode',
            title: this.$t('setAccount.viewAccount.legalEntityRegionCode'),
          },
          { field: 'registrationCode', title: this.$t('setAccount.viewAccount.registrationCode') },
          { field: 'legalAddress', title: this.$t('setAccount.viewAccount.legalAddress') },
        ],
      };
    },
  };
</script>
<style lang="scss" scoped>
  .sureInformation .collapse-content {
    padding-top: 10px;
  }
</style>
